
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React, { ChangeEvent, useEffect, useState } from "react";
import { Card, Container } from "react-bootstrap";
import { useAuth } from "../../../../contexts/AuthContext";
import { QueryListProvider } from "../../../../component/solution/QueryList/QueryListContext";
import { QueryList } from "../../../../component/solution/QueryList/QueryList";
import {Search, X} from "lucide-react";
import { CastType, IQuery, IWhere } from "../../../../component/solution/Interfaces";
import { formatDateFull } from "../../../../component/solution/utils/AppUtil";

enum StockStatus {
    TO_SEND = "TO_SEND",
    SENT = "SENT",
    SUCCESS = "SUCCESS", // M24L Validation Success,
    ERROR = "ERROR", // M24L Validation Success,
}

export const StockMaster: React.FC = () => {

    const {fetchData, token}  = useAuth();
    const [resultElements, setResultElements] = useState<React.ReactElement[]>([]);
    const [search, setSearch] = useState<Map<string, string>>(new Map<string, string>());
    const [queryState, setQueryState] = useState<IQuery>(
        {
            tableName: "sa_m24l_item",
            select: [
                {
                    fullColumnName: "item_code",
                    aggregate: ""
                },
                {
                    fullColumnName: "name",
                    aggregate: ""
                },
                {
                    fullColumnName: "barcode",
                    aggregate: ""
                },
                {
                    fullColumnName: "integration_status",
                    aggregate: ""
                },                                                
                {
                    fullColumnName: "created",
                    aggregate: ""
                },
                {
                    fullColumnName: "updated",
                    aggregate: ""
                },
            ],
            groupBy: [],
            join: [],
            orderBy: [ 
                {
                    fullColumnName: "item_code",
                    direction: "ASC",
                    cast: CastType.STRING
                }
            ],
            where: [],
            mainTableOnly: false,
            includeExtraColumns: false,
            includeControlColumns: true,
            modifiedAfter: null,
            touchedBefore: null,
            isDirty: null,
            pageNum: 0,
            pageSize: 50,
            frontEndOnly: null
        }        
    );

    // useEffect(() => {
    //     fetchStockItems();
    //     // const intervalId = setInterval(() => {
    //     //     fetchStockItems();
    //     // }, 15000);        
    // }, [queryState]);

    // useEffect(() => {
    //     const searchFields = new Map<string, string>()
    //     searchFields.set("item_code", "");
    //     searchFields.set("name", "");
    //     searchFields.set("barcode", "");
    //     searchFields.set("integration_status", "");
    //     setSearch(searchFields);        
    // }, []);



    // const processResult = (result: any) => {
    //     const shipments: any[] = result.data;
    
    //     // Build React elements and set state
    //     const resultElements: React.ReactElement[] = shipments.map((record, index) => (
    //         <tr key={index}>
    //             <td>{record.data?.item_code}</td>
    //             <td>{record.data?.name}</td>
    //             <td>{record.data?.barcode}</td>
    //             <td className="bg-success text-dark text-center">{record.data?.integration_status}</td>
    //             <td style={{whiteSpace: "nowrap"}}>{formatDateFull(record.control?.created)}</td>
    //             <td style={{whiteSpace: "nowrap"}}>{formatDateFull(record.control?.updated)}</td>
    //         </tr>
    //     ));

    //     setResultElements(resultElements);
    // }

    // const fetchStockItems = () => {
    //     const queryUrl: string = `${process.env.REACT_APP_BASE_URL}/${"query/data"}`;


    //     fetchData(queryUrl, {method:"POST", body: JSON.stringify(queryState)}, processResult);        
    // }

    // const searchClicked = () => {
    //     let where: IWhere[] = [];

    //     search.forEach((value: string, column: string) => {
    //         console.log(column + " : " + value);
    //         if(value && value.length){
    //             const clause: IWhere = {
    //                 fullColumnName: column,
    //                 value: '%' + value + '%',
    //                 operator: "LIKE",
    //                 cast: CastType.STRING
    //             }
    //             where.push(clause);
    //         }
    //     });    

    //     const query = {...queryState}
    //     query.where = where;
    //     query.pageNum = 0;
    //     setQueryState(query);
    //     console.log(query);
    // }

    // const clearClicked = () => {

    //     const search = new Map<string, string>()
    //     search.set("item_code", "");
    //     search.set("name", "");
    //     search.set("barcode", "");
    //     search.set("integration_status", "");
    //     setSearch(search);

    //     let where: IWhere[] = [];

    //     search.forEach((value: string, column: string) => {
    //         console.log(column + " : " + value);
    //         if(value && value.length){
    //             const clause: IWhere = {
    //                 fullColumnName: column,
    //                 value: '%' + value + '%',
    //                 operator: "LIKE",
    //                 cast: CastType.STRING
    //             }
    //             where.push(clause);
    //         }
    //     });  

    //     const query = {...queryState}
    //     query.where = where;
    //     setQueryState(query);      
    // }
    
    // const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    //     if(event.target.type === 'text') {
    //         setSearch(prevSearch => {
    //             const newSearch = new Map(prevSearch);
    //             newSearch.set(event.target.id, event.target.value);
    //             return newSearch;
    //         });
    //     }
    // }

    /* 

    Status 

    Stock Master - Activity Status

    TO_SEND - Item master ready to be sent to M24L.
    SENT - Item master has been sent to M24L for processing.
    ERROR - There was a problem integrating the item master at M24L.
    SUCCESS - Item master successfully received at M24L for processing.
    
    */ 

    /*
    
item_group
article_code
gender
end_use
silhouette
sub_silhouette
minimum_quantity
maximum_quantity


    */

    return(
        <React.Fragment>
            <Container fluid className="p-0">
            <QueryListProvider>
                    <QueryList
                        listTitle={"Stock Master - Activity Status"}
                        recordTitle={"Stock Master - Activity Status"}
                        tableName={"sa_m24l_item"}
                        editTableName={"sa_m24l_item"}
                        editHasCompoundKey={false}
                        hasIntegrationStatusLegend={true}
                        integrationstatusLegend={[
                            { status: 'ERROR', color: '#bf3636', description: 'There was a problem integrating the item master at M24L.'},
                            { status: 'TO_SEND', color: '#d4a53f', description: 'Item master ready to be sent to M24L.'},
                            { status: 'SENT', color: '#d4a53f', description: 'Item master has been sent to M24L for processing.'},
                            { status: 'SUCCESS', color: '#3ec76b', description: 'Item master successfully received at M24L for processing.'}
                        ]}
                        join={[]} 
                        select={[
                            {
                                fullColumnName: "item_code",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "item_group",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "name",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "barcode",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "article_code",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "gender",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "end_use",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "silhouette",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "sub_silhouette",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "minimum_quantity",
                                aggregate: ""
                            },
                             {
                                fullColumnName: "maximum_quantity",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "integration_status",
                                aggregate: ""
                            },                                                
                            {
                                fullColumnName: "created",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "updated",
                                aggregate: ""
                            },
                        ]}
                        where={[]} 
                        orderBy={[    
                            {
                             fullColumnName: "item_code",
                             direction: "ASC",
                             cast: CastType.STRING
                            }
                         ]} 
                        groupBy={[]}                   
                    />
                </QueryListProvider>



                {/* <Card>
                    <Card.Header>
                        <Card.Title>{"Stock Master - Activity Status"}</Card.Title>
                    </Card.Header>

                    <div className="ms-4 me-4" style={{}}>

                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    {Array.from(search).map(([key, value]) => (
                                        <td>
                                            <input id={key} name={key} value={value} onChange={handleOnChange} type="text" autoComplete="off" placeholder={`Search by ${key}...`} className="form-control form-control-md"></input>
                                        </td>
                                    ))}
                                    <td colSpan={2}><Search color="#c84338" onClick={searchClicked} className="custom-icon text-center align-middle" /><X color="#c84338" onClick={clearClicked} style={{width: "36px", height: "36px"}} className="custom-icon text-center align-middle ms-5"/></td>

                                </tr>
                                <tr>
                                    <td><b>Code</b></td>
                                    <td><b>Status</b></td>
                                    <td><b>Name</b></td>
                                    <td><b>Barcode</b></td>
                                    <td><b>Created</b></td>
                                    <td><b>Updated</b></td>
                                </tr>
                            </thead>
                            <tbody>
                                {resultElements}                                                                                                                                                               
                            </tbody>
                        </table>
                    </div>

                </Card> */}
            </Container>
        </React.Fragment>
    );
}